/** One hand-off into the mounted-session Copilot conversation workspace. */
import { requestDrawerPanel } from '@solum/ui'
import type { Ctx } from './brain'
import { queueCopilotLaunch } from './conversationStore'

export interface CopilotLaunch {
  id: string
  query: string
  contextSnapshot: Ctx
}

type Listener = (request: CopilotLaunch) => void
const listeners = new Set<Listener>()
let sequence = 0

function snapshot(context: Ctx): Ctx {
  return Object.freeze({
    ...context,
    ...(context.blockIds ? { blockIds: Object.freeze([...context.blockIds]) as unknown as string[] } : {}),
  })
}

/** An empty query is valid for Cmd/Ctrl-J; a non-empty one is consumed once. */
export function launchCopilot(input: { query?: string; contextSnapshot: Ctx }): boolean {
  const request: CopilotLaunch = {
    id: `launch-${Date.now()}-${++sequence}`,
    query: input.query?.trim() ?? '',
    contextSnapshot: snapshot(input.contextSnapshot),
  }
  queueCopilotLaunch(request)
  for (const listener of listeners) listener(request)
  requestDrawerPanel('copilot')
  return true
}

export function onCopilotLaunch(listener: Listener): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
